import { WORK_ITEMS } from "@/lib/content/work";

/** Same order as GROWTH_SERVICE_CONFIG.workItemIds */
export const DIGITAL_EXPERIENCES_TOP_ORDER = [
  "anxious-generation",
  "good-inside",
  "childhood-index",
  "safdie-architects",
  "fabrik",
] as const;

export function sortDigitalExperiencesWork<T extends { id: string }>(
  items: T[],
): T[] {
  const rank = (id: string) => {
    const pri = DIGITAL_EXPERIENCES_TOP_ORDER.indexOf(
      id as (typeof DIGITAL_EXPERIENCES_TOP_ORDER)[number],
    );
    if (pri !== -1) return pri;
    return (
      DIGITAL_EXPERIENCES_TOP_ORDER.length +
      WORK_ITEMS.findIndex((w) => w.id === id)
    );
  };
  return [...items].sort((a, b) => rank(a.id) - rank(b.id));
}
